import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRightIcon, ChevronRightIcon, MinusIcon } from '@icons';
import classNames from 'classnames';
import React, { useCallback, useMemo, useRef } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import { Link } from '../link/link';
import styles from './breadcrumb.module.scss';
const BreadCrumbItem = React.memo(({ id, onSelected, showChevron, icon = 'chevron', size = 'sm', selected, name, RTL, }) => {
    const ref = useRef(null);
    useFocusNew(ref);
    const breadCrumbIcon = useMemo(() => {
        return classNames(styles.bread_crumb_icon, RTL ? styles.rtl_icon : '', {
            [styles[`bread_crumb_icon_${size}`]]: true,
            [styles.slash]: icon === 'slash',
        });
    }, []);
    const breadCrumbNode = useMemo(() => {
        return classNames(styles.bread_crumb_node, {
            [styles[`bread_crumb_node_${size}`]]: true,
        });
    }, [selected]);
    const handleClick = useCallback((id, name) => {
        onSelected?.(id, name);
    }, []);
    return (_jsxs("li", { className: styles.bread_crumb, children: [_jsx("span", { className: breadCrumbNode, children: _jsx(Link, { onClick: () => handleClick(id, name), highlight: selected, children: name }) }), showChevron && (_jsxs("span", { className: breadCrumbIcon, children: [icon === 'chevron' && _jsx(ChevronRightIcon, {}), icon === 'arrow' && _jsx(ArrowRightIcon, {}), icon === 'slash' && _jsx(MinusIcon, {})] }))] }, id));
});
BreadCrumbItem.displayName = 'BreadCrumbItem';
export { BreadCrumbItem };
